import {EdgeRuleError, ResponseError} from '@amicamutual/amica-common';

interface Error {
  status: number;
  message: string;
  payload?: ErrorPayload;
  ruleErrors?: EdgeRuleError[];
}

/**
 * Custom Amica error response payload
 * @prop errors - list of applicable errors
 */
interface ErrorPayload {
  errors?: ReadonlyArray<ErrorResponse>;
}

interface ErrorResponse {
  code?: ErrorResponseCode | string;
  messsage?: string;
}

enum ErrorResponseCode {
  INVALID_ROUTING_NUM_CODE = 'ROUTING_NUMBER_INVALID',
  NOT_ELIGIBLE_FOR_TEXT_ENROLLMENT = 'NOT_ELIGIBLE_FOR_ENROLLMENT'
}

export const buildErrorFromPayload = (payload: any): Error =>
  payload
    ? payload.response
      ? {status: payload.response.status ? payload.response.status : 500, message: payload.message}
      : {status: payload.status ? payload.status : 500, message: payload.message}
    : {
        status: 500,
        message: 'Network Error'
      };

export const buildResponseErrorFromPayload = (payload: any): ResponseError => {
  const status = payload?.status
    ? `${payload.status}`
    : payload?.response?.status
      ? `${payload.response.status}`
      : '500';

  return payload
    ? payload.data
      ? {status: payload.data.status ? `${payload.data.status}` : status, error: payload.data.error}
      : payload.response
        ? {status: payload.response.status ? `${payload.response.status}` : '500', error: payload.message}
        : {status: status}
    : {status: status};
};

export default Error;
